module.exports = __webpack_public_path__ + "static/media/18ECA38.6e64297f.jpg";